
import React, { FC, forwardRef, RefAttributes } from 'react';
import { INPUT_MASK_CHAR } from '@trip-ux/constants';
import { TextInput } from '@trip-ux/components';
import { FieldRenderProps } from 'react-final-form';
import { get, defaultTo } from 'lodash';

export const GenericTextInput: FC<FieldRenderProps<string> & RefAttributes<HTMLInputElement> & { ariaLabel?: string }> =
  forwardRef(
    (
      {
        label: propLabel,
        labels,
        ariaLabel,
        input,
        meta,
        required,
        placeholder,
        showLabel = false,
        className = '',
        disabled = false,
        id,
        maxLength,
        validateOnActive = true,
        inputOnChange,
        inputOnBlur,
        type,
        mask,
        maskChar,
        newLabel = '',
      },
      ref
    ) => {
      const label = newLabel ? defaultTo(propLabel, get(labels, newLabel, '')) :
       defaultTo(propLabel, get(labels, input.name, ''));

      return (
        <div className={`mb-auto space-between ${className}`}>
          <TextInput
            {...input}
            onChange={val => {
              input.onChange(val);
              inputOnChange && inputOnChange(val);
            }}
            onBlur={event => {
              input.onBlur(event as React.FocusEvent<HTMLElement>);
              inputOnBlur && inputOnBlur(event);
            }}
            id={id ? id : input.name}
            disabled={disabled}
            type={type || 'text'}
            className="my-auto text-input-policy"
            placeholder={defaultTo(placeholder, label)}
            mask={mask}
            maskChar={maskChar || INPUT_MASK_CHAR.NONE}
            error={(!validateOnActive || !meta.active) && meta.touched && meta.error}
            ref={ref}
            maxLength={maxLength}
            showLabel={showLabel}
            required={required}>
            {showLabel ? label : ariaLabel}
          </TextInput>
        </div>
      );
    }
  );
GenericTextInput.displayName = 'GenericTextInput';
